import { z } from 'zod';
/** A notice longer than this would hold a deploy, and the stop timeout of the container. */
export const MAX_RESTART_NOTICE_SECONDS = 60;
/**
 * Server → every player of a process that received its stop signal: the game
 * closes in `seconds`, then the session ends with `CLOSE_CODE_SERVER_RESTART`.
 * A count rather than a time of day, so a client's clock cannot shorten it.
 */
export const ServerRestartEventSchema = z
    .object({ seconds: z.number().int().min(1).max(MAX_RESTART_NOTICE_SECONDS) })
    .strict();
//# sourceMappingURL=server-restart.js.map